import React from 'react';
import {motion} from 'framer-motion';
import {ClipboardList, Handshake, Phone} from 'lucide-react';

const steps = [
    {
        icon: Phone,
        title: 'Bezpłatna Konsultacja',
        desc: 'Zadzwoń lub napisz - doradzimy, jakie kamery i zabezpieczenia sprawdzą się w Twoim domu lub firmie w Mielcu i okolicach do 250 km. Umawiamy bezpłatną wizję lokalną, byś wiedział dokładnie, czego potrzebujesz.',
        color: 'from-blue-500/20 to-cyan-500/20',
        iconColor: 'text-blue-500',
    },
    {
        icon: ClipboardList,
        title: 'Wycena bez Niespodzianek',
        desc: 'Na miejscu dobieramy sprzęt i rozwiązania dopasowane do Twojego budżetu. Dostajesz przejrzysty kosztorys - wiesz za co płacisz, bez ukrytych kosztów.',
        color: 'from-emerald-500/20 to-teal-500/20',
        iconColor: 'text-emerald-500',
    },
    {
        icon: Handshake,
        title: 'Montaż i Spokój na Lata',
        desc: 'Montujemy system szybko i profesjonalnie, szkolimy z obsługi i zapewniamy gwarancję. Zyskujesz ochronę, która działa od pierwszego dnia - bez stresu i komplikacji.',
        color: 'from-violet-500/20 to-purple-500/20',
        iconColor: 'text-violet-500',
    },
];

export function CooperationSection() {
    return (
        <section className="w-full py-20 md:py-28 px-5 bg-muted/50 relative overflow-hidden">
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div
                    className="absolute top-0 left-1/4 w-[min(384px,80vw)] h-[min(384px,80vw)] bg-primary/5 rounded-full blur-[120px]"/>
                <div
                    className="absolute bottom-0 right-1/4 w-[min(384px,80vw)] h-[min(384px,80vw)] bg-blue-500/5 rounded-full blur-[120px]"/>
            </div>

            <div className="max-w-6xl mx-auto relative">
                <motion.div
                    initial={{opacity: 0}}
                    whileInView={{opacity: 1}}
                    viewport={{once: true}}
                    transition={{duration: 0.6}}
                    className="text-center mb-16"
                >
                    <div
                        className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-border bg-primary/5 text-xs md:text-sm font-semibold text-primary mb-4">
                        3 proste kroki do bezpieczeństwa
                    </div>
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-4">
                        Jak zamówić <span className="gradient-text">monitoring w Mielcu?</span>
                    </h2>
                    <p className="text-muted-foreground max-w-xl mx-auto">
                        Bez formalności, bez stresu. Od pierwszego telefonu po gotowy system monitoringu w Twoim domu
                        lub firmie w&nbsp;Mielcu i promieniu do 250 km mija zaledwie kilka dni.
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-3 gap-6">
                    {steps.map((step, i) => {
                        const Icon = step.icon;
                        return (
                            <motion.div
                                key={step.title}
                                initial={{opacity: 0}}
                                whileInView={{opacity: 1}}
                                viewport={{once: true}}
                                transition={{duration: 0.5, delay: i * 0.15}}
                                className="group relative rounded-2xl border border-border/50 bg-card backdrop-blur-sm p-6 hover:border-primary/30 hover:shadow-lg transition-all"
                            >
                                <div
                                    className="absolute -top-3 -left-1 w-8 h-8 rounded-full bg-primary text-white font-bold text-sm flex items-center justify-center shadow-lg shadow-primary/30">
                                    {i + 1}
                                </div>
                                <div className="flex items-center gap-3 mb-4 mt-2">
                                    <div
                                        className={`w-12 h-12 rounded-xl bg-gradient-to-br ${step.color} flex items-center justify-center ${step.iconColor}`}>
                                        <Icon size={24}/>
                                    </div>
                                    <h3 className="font-semibold text-lg text-foreground">{step.title}</h3>
                                </div>
                                <p className="text-muted-foreground text-sm leading-relaxed">{step.desc}</p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
